import React from 'react';
import { FiX } from 'react-icons/fi';

const FiXComponent = FiX as unknown as React.ComponentType<{
    size?: number | string;
    className?: string;
}>;

interface ExportModalProps {
    isOpen: boolean;
    onClose: () => void;
    onExport: () => void;
    onSnapshot: () => void;
    loading?: boolean;
    isAllSelected?: boolean;
}

const ExportModal: React.FC<ExportModalProps> = ({
    isOpen,
    onClose,
    onExport,
    onSnapshot,
    loading = false,
    isAllSelected = false,
}) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white rounded-lg shadow-lg w-[480px] max-w-[90%] p-6">
                {/* Header */}
                <div className="flex justify-between items-center mb-4">
                    <h3 className="text-lg font-semibold text-[#3F5265]">
                        Export Options
                    </h3>
                    <button
                        onClick={onClose}
                        className="text-gray-400 hover:text-gray-600 transition-colors"
                        disabled={loading}
                    >
                        <FiXComponent size={20} />
                    </button>
                </div>

                {/* Content */}
                <div className="mb-6">
                    <p className="text-[#657584] text-sm">
                        {isAllSelected
                            ? 'Would you like to export?'
                            : 'Would you like to see snapshot preview or export?'
                        }
                    </p>
                </div>

                {/* Buttons - Right aligned */}
                <div className="flex justify-end gap-3">
                    {!isAllSelected && (
                        <button
                            onClick={() => {
                                onSnapshot();
                            }}
                            disabled={loading}
                            className="px-5 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            {loading ? 'Loading...' : 'Snapshot'}
                        </button>
                    )}
                    <button
                        onClick={() => {
                            onExport();
                        }}
                        disabled={loading}
                        className="px-5 py-2 bg-orange-500 text-white rounded-md text-sm font-medium hover:bg-orange-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        {loading ? 'Loading...' : 'Export'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ExportModal;